var _rect, _rect2, _rect3, _path, _path2, _path3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAduhuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 114,
    viewBox: "0 0 404 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.278,
    y: 11.2375,
    width: 22.5892,
    height: 88.851,
    rx: 11.2946,
    transform: "rotate(19.7612 41.278 11.2375)",
    stroke: "#20AFFF",
    strokeOpacity: 0.7,
    strokeWidth: 17.5694
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.29726,
    y: -11.2375,
    width: 22.5892,
    height: 88.851,
    rx: 11.2946,
    transform: "matrix(0.94111 -0.3381 -0.3381 -0.94111 55.3255 93.9768)",
    stroke: "#20AFFF",
    strokeOpacity: 0.7,
    strokeWidth: 17.5694
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7847,
    y: -8.7847,
    width: 22.5892,
    height: 88.851,
    rx: 11.2946,
    transform: "matrix(1 0 0 -1 85.9232 92.6329)",
    stroke: "#4B88FF",
    strokeOpacity: 0.7,
    strokeWidth: 17.5694
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.548 99.4467L108.32 100.721C106.436 101.013 104.467 100.809 102.657 100.131C94.1986 96.9586 92.854 85.7161 99.957 80.687C101.365 79.6902 102.986 79.0367 104.692 78.7789L115.068 77.2105C122.451 76.0945 128.511 70.7882 130.593 63.6175C131.097 61.8828 131.352 60.0856 131.352 58.2793V57.9405C131.352 55.1881 130.818 52.4572 129.805 49.9268C129.151 48.2917 128.29 46.724 127.244 45.2857C123.882 40.663 118.807 37.5809 113.155 36.7292L104.778 35.467C103.03 35.2036 101.369 34.5301 99.9311 33.5015C92.7304 28.3506 94.1513 17.0433 102.641 13.8596C104.463 13.1763 106.44 12.9723 108.347 13.2675L116.548 14.5375C165.062 22.0504 165.062 91.9338 116.548 99.4467Z",
    stroke: "#4B88FF",
    strokeOpacity: 0.7,
    strokeWidth: 17.5694
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.42 71.4635L211.42 71.4634L211.479 71.2824C211.479 71.2824 211.479 71.2824 211.479 71.2824C211.874 70.0584 212.076 68.78 212.076 67.4938L212.076 24.7768C212.076 23.3672 212.352 21.9713 212.889 20.6679C217.389 9.73565 233.661 12.9542 233.661 24.7768V71.8229C228.496 111.817 170.483 111.691 165.391 71.829L165.391 24.8729C165.391 12.8031 181.983 9.48244 186.628 20.6224C187.189 21.9691 187.479 23.4138 187.479 24.8728L187.479 67.6903C187.479 68.5343 187.566 69.3759 187.738 70.2018C190.314 82.5181 207.55 83.4363 211.42 71.4635Z",
    stroke: "#5012FF",
    strokeOpacity: 0.6,
    strokeWidth: 17.5694
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 71.3667L372.974 71.3667L373.033 71.1857C373.033 71.1857 373.033 71.1857 373.033 71.1856C373.429 69.9616 373.63 68.6833 373.63 67.397L373.63 24.68C373.63 23.2705 373.906 21.8745 374.443 20.5711C378.944 9.63891 395.215 12.8574 395.215 24.68V71.7262C390.05 111.72 332.037 111.594 326.946 71.7322L326.946 24.7761C326.946 12.7063 343.537 9.3857 348.182 20.5257C348.744 21.8724 349.033 23.317 349.033 24.7761L349.033 67.5936C349.033 68.4375 349.12 69.2791 349.293 70.1051C351.869 82.4214 369.105 83.3396 372.974 71.3667Z",
    stroke: "#DB02FE",
    strokeOpacity: 0.7,
    strokeWidth: 17.5694
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7847,
    y: -8.7847,
    width: 22.5892,
    height: 88.851,
    rx: 11.2946,
    transform: "matrix(1 0 0 -1 237.357 92.6329)",
    stroke: "#A017D0",
    strokeOpacity: 0.6,
    strokeWidth: 17.5694
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7847,
    y: -8.7847,
    width: 22.5892,
    height: 88.851,
    rx: 11.2946,
    transform: "matrix(1 0 0 -1 283.037 92.6329)",
    stroke: "#A017D0",
    strokeOpacity: 0.6,
    strokeWidth: 17.5694
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7847,
    y: 8.7847,
    width: 22.5892,
    height: 66.7638,
    rx: 11.2946,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 238.862 36.9128)",
    stroke: "#A017D0",
    strokeOpacity: 0.6,
    strokeWidth: 17.5694
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAduhuLogo);
export default __webpack_public_path__ + "static/media/aduhu_logo.0982a7eb17f96e33dfdd0e7c77a6ce6f.svg";
export { ForwardRef as ReactComponent };